import { FC, useState } from 'react';
import { GoGraph } from 'react-icons/go';
import { TSTitleCard } from '../../../components/shared/card/Card';
import { CustomIntervalTimePicker } from '../../../components/shared/date/CustomIntervalTimePicker';
import { dayDiff } from '../../../helpers/dateHelper';
import { handleError } from '../../../services/gql/config/URQLProvider';
import strings from '../home.translations';
import { ResourcesCostSummaryCard, ResourcesCostType } from './ResourcesCostSummaryCard';
import { useSummaryData } from './useSummaryData';

export const ResourcesCostSummarySection: FC = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const start = new Date(today);
  start.setDate(start.getDate() - 6);
  const [[startDate, endDate], setDatePair] = useState<[Date, Date]>(() => [start, today]);

  const { summaryData, error, fetching } = useSummaryData(startDate, endDate);
  if (error) handleError(error);

  const formattedString =
    dayDiff(startDate, endDate) === 0
      ? strings.resourcesCostSummary.previousDay
      : strings.resourcesCostSummary.previousDays(dayDiff(startDate, endDate) + 1);

  return (
    <TSTitleCard
      title={strings.resourcesCostSummary.title}
      descriptor={formattedString}
      icon={GoGraph}
      longString
      largeContent={
        <CustomIntervalTimePicker
          startDate={startDate}
          endDate={endDate}
          onChange={setDatePair}
          dayDiff={dayDiff(startDate, endDate)}
          labels={{
            previous: { hide: true },
            next: { hide: true }
          }}
        />
      }
    >
      <div className="grid grid-cols-1 lg:grid-cols-3">
        <ResourcesCostSummaryCard
          type={ResourcesCostType.TIME}
          title={strings.resourcesCostSummary.cardTitle.time}
          summaryData={summaryData}
          fetching={fetching}
          dayDiff={dayDiff(startDate, endDate)}
        />
        <ResourcesCostSummaryCard
          type={ResourcesCostType.COST}
          title={strings.resourcesCostSummary.cardTitle.cost}
          summaryData={summaryData}
          fetching={fetching}
          dayDiff={dayDiff(startDate, endDate)}
        />
        <ResourcesCostSummaryCard
          type={ResourcesCostType.STAFF}
          title={strings.resourcesCostSummary.cardTitle.staff}
          summaryData={summaryData}
          fetching={fetching}
          dayDiff={dayDiff(startDate, endDate)}
        />
      </div>
    </TSTitleCard>
  );
};
